import { useEffect, useState } from 'react';

const mobileRegex = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
const isMobileUserAgent = () => mobileRegex.test(navigator.userAgent);
export const useDeviceDetector = () => {
  const [isMobile, setIsMobile] = useState(isMobileUserAgent);

  useEffect(() => {
    setIsMobile(isMobileUserAgent());
  }, []);

  return { isMobile };
};
